// monitor/src/apiBase.ts
declare global {
  interface Window {
    __ENV__?: Record<string, string>;
  }
}

export const API_BASE =
  window.__ENV__?.API_BASE_URL ||
  process.env.REACT_APP_API_BASE ||
  "http://localhost:8000";